module.exports = __webpack_public_path__ + "img/icon-contacts.9fbd4e38.svg";